module.exports = __webpack_public_path__ + "img/pc_banner3.34ca64e7.png";